import React from 'react';
import { i18n } from 'config/locales';

import ValidationElement, {
  ValidationElementProps,
} from 'components/Form/ValidationElement/ValidationElement';
import { CommonOnUpdate, CommonRequired, CommonOnError } from 'types/props';
import { HistoryEmploymentItemModel } from 'forms/sections/history/employment/types';
import { FieldModel } from 'forms/shared/types/field';
import RadioGroup from 'components/Form/RadioGroup';
import Radio from 'components/Form/Radio';

type Status = HistoryEmploymentItemModel['Status']

interface Props extends ValidationElementProps, Status {
  onUpdate?: CommonOnUpdate
  required?: CommonRequired
  onError?: CommonOnError
  disabled?: boolean
  attribute?: string
}

export default class EmploymentStatus extends ValidationElement<Props> {
  /**
   * Handle the change event.
   */
  handleFieldChange = (values: FieldModel) => {
    this.props.onUpdate({
      name: this.props.name,
      value: values.value,
    });
  };

  render() {
    return (
      <RadioGroup
        attribute={this.props.attribute}
        className="employment-status option-list"
        selectedValue={this.props.value}
        required={this.props.required}
        onError={this.props.onError}
      >
        <Radio
          name="employment_status"
          label={i18n.t('history.employment.default.status.fullTime')}
          value="FullTime"
          className="fulltime"
          disabled={this.props.disabled}
          onUpdate={this.handleFieldChange}
          onError={this.props.onError}
        />
        <Radio
          name="employment_status"
          label={i18n.t('history.employment.default.status.partTime')}
          value="PartTime"
          className="parttime"
          disabled={this.props.disabled}
          onUpdate={this.handleFieldChange}
          onError={this.props.onError}
        />
      </RadioGroup>
    );
  }
}

EmploymentStatus.defaultProps = {
  // TODO: Remove
  onUpdate: (queue) => {},
  // TODO: Remove
  onError: (value, arr) => arr,
};
